import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ReactNode } from "react";

import { VacancyDetailContext } from "./VacancyDetailContext";

import { instance } from "@/lib/axios/instance";
import { VacancyType } from "@/types/vacancy/VacancyType";

interface ApiErrorResponse {
    message: string;
}

type VacancyDetailProviderProps = {
    children: ReactNode
    clientId?: string;
    vacancyId: string;
}

export const VacancyDetailProvider = ({
  children,
  clientId,
  vacancyId }: VacancyDetailProviderProps) => {
  const { data: vacancy, isLoading: vacancyLoading, isFetching: vacancyFetching, error: vacancyError }: UseQueryResult<VacancyType, AxiosError<ApiErrorResponse>> = useQuery({
    queryKey: ['vacancy', clientId, vacancyId],
    queryFn: () => instance.get(`/api/v2/Vacancies/${vacancyId}?clientId=${clientId}`)
      .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
    enabled: !!vacancyId,
    placeholderData: keepPreviousData,
    retry: false
  });

  return (
    <VacancyDetailContext.Provider
      value={{
        vacancy,
        vacancyError,
        vacancyFetching,
        vacancyLoading,
      }}
    >
      {children}
    </VacancyDetailContext.Provider>
  );
};